import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';

export class DwellingInspectionInvoicePoint extends ModelBase {
  constructor(model?: any) {
    super();
    if (model) {
      this.id = model.id;
      this.priceListItemId = model.priceListItemId;
      this.priceListQuantity = model.priceListQuantity;
      this.amountExVat = model.amountExVat;
      this.amountIncVat = model.amountIncVat;
      this.dwellingInspectionId = model.dwellingInspectionId;
      this.invoiceText = model.invoiceText;
    } else {
      this.priceListQuantity = 1;
    }
  }

  priceListItemId: string;
  priceListQuantity: number;
  dwellingInspectionId: string;
  invoiceText: string;
  amountExVat: Money;
  amountIncVat: Money;
}
